<template>
  <div :class="[$style.box, slideType == 1 ? $style['box-slide-down'] : $style['box-slide-up']]">
    <!-- 左上角标题 -->
    <p :class="$style.title">{{ title }}</p>
    <div
      :style="{ width: `${bannerLength + 10}px` }"
      :class="$style['banner-content']"
      @touchstart.stop="bannerStart($event)"
      @touchmove.stop="bannerOn($event)"
      @touchend.stop="bannerEnd($event)"
      @touchcancel="bannerEnd($event)"
    >
      <ul
        :style="{
          width: `${bannerLength * newgameBannerList.length}px`,
          transform: `translateX(${-(currentIndex * bannerLength)}px)`,
        }"
      >
        <li
          v-for="item in newgameBannerList"
          :key="item.id"
          ref="bannerList"
          :style="{ width: `${bannerLength}px` }"
        >
          <div>
            <img :src="item.background" alt="背景图" @click="handleLinkTo(item, 1)" />
            <!-- 游戏描述 -->
            <div :class="$style.description">
              {{ item.description }}
            </div>
            <!-- 预约下载 -->
            <div :class="$style.down" @click="handleLinkTo(item, 2)">
              {{ item.button_text }}
            </div>
          </div>
        </li>
      </ul>
    </div>
    <!-- 控制条 -->
    <div :class="$style.contorl">
      <ul :style="{ width: `${15 * newgameBannerList.length}px` }">
        <li
          :class="currentIndex === index && $style.choose"
          v-for="(item, index) in newgameBannerList"
          :key="index"
        ></li>
      </ul>
    </div>
    <!-- 返回栏 -->
    <div
      :class="$style.back"
      @touchstart="moveStart($event)"
      @touchmove="moveOn($event)"
      @touchend="moveEnd($event)"
    >
      <div>
        <i></i>
        <i></i>
      </div>
      <p>上划回到黑喵论坛</p>
    </div>
  </div>
</template>

<script>
let vm = '';
import { mapActions, mapState, mapMutations } from 'vuex';
import { reportData } from '@/api/report';
export default {
  props: {
    newgameBannerList: {
      type: Array,
      default: function () {
        return [];
      },
    },
    isFirstEnter: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      startX: 0,
      startY: 0,
      isLeft: false,
      isRight: false,
      bannerRun: false, // 当前是否在轮播
      currentIndex: 0, // 当前轮播图
      bannerTime: 500, // 轮播图时间
      bannerTimer: null,
      bannerLength: 0,
      slideType: 1, // 1代表下拉，2代表上滑
    };
  },
  computed: {
    title() {
      return this.newgameBannerList[this.currentIndex]
        ? this.newgameBannerList[this.currentIndex].title
        : '';
    },
  },
  watch: {
    currentIndex: {
      handler(newValue) {
        reportData({
          type: 7,
          data_type: 1,
          recommend_id: vm.newgameBannerList.length && vm.newgameBannerList[newValue].id
        })
      },
    }
  },
  mounted() {
    vm = this;
    this.bannerLength = Number(document.body.offsetWidth) - 31;
    reportData({
      type: 7,
      data_type: 1,
      recommend_id: this.newgameBannerList[0].id
    })
  },
  activated() {
    // 当不是首次进入页面，且不是从详情页返回的时候初始化并获取数据
    if (!this.$route.meta.isBack && !this.isFirstEnter) {
      this.startX = 0
      this.startY = 0
      this.isLeft = false
      this.isRight = false
      this.bannerRun = false // 当前是否在轮播
      this.currentIndex = 0 // 当前轮播图
      this.bannerTime = 500 // 轮播图时间
      this.bannerTimer = null
      this.bannerLength = 0
      this.slideType = 1
    }
  },
  methods: {
    ...mapMutations('gameCenter', {
      CHANGE_STATE: 'CHANGE_STATE'
    }),
    bannerLeft() {
      if (this.bannerRun) return;
      this.bannerRun = true;
      setTimeout(() => {
        this.bannerRun = false;
      }, this.bannerTime);
      const num = this.newgameBannerList.length - 1;
      if (this.currentIndex === 0) {
        return;
      }
      this.currentIndex--;
    },
    bannerRight(flag) {
      if (this.bannerRun) return;
      this.bannerRun = true;
      setTimeout(() => {
        this.bannerRun = false;
      }, this.bannerTime);
      const num = this.newgameBannerList.length - 1;
      if (this.currentIndex === num) {
        if (flag) {
          this.currentIndex = 0;
        }
        return;
      }
      this.currentIndex++;
    },
    bannerStart(e) {
      clearInterval(this.bannerTimer);
      this.startX = e.touches[0].pageX;
    },
    bannerOn(e) {
      e.preventDefault();
      const moveEndX = e.changedTouches[0].pageX;
      const X = moveEndX - this.startX;
      if (X > 0) {
        // right
        this.isRight = true;
      } else if (X < 0) {
        // left
        this.isLeft = true;
      }
    },
    bannerEnd(e) {
      if (this.isRight) {
        this.bannerLeft();
      } else if (this.isLeft) {
        this.bannerRight();
      }
      this.startX = 0;
      this.isLeft = false;
      this.isRight = false;
    },
    moveStart(e) {
      this.startY = e.touches[0].pageY;
    },
    moveOn(e) {
      e.preventDefault();
    },
    moveEnd(e) {
      const moveEndY = e.changedTouches[0].pageY;
      const Y = this.startY - moveEndY;
      if (Y > 50) {
        reportData({
          type: 7,
          data_type: 5,
          recommend_id: this.newgameBannerList[this.currentIndex].id
        })
        this.slideType = 2
        this.$emit('changeSlideType', 2)
        setTimeout(() => {
          this.$emit('closeNewgame')
        }, 1000);
      }
    },
    handleLinkTo(item, type) {
      if (type === 1) {
        reportData({
          type: 7,
          data_type: 3,
          recommend_id: item.id
        })
      } else {
        reportData({
          type: 7,
          data_type: 2,
          recommend_id: item.id
        })
      }
      setTimeout(() => {
        window.open(item.url, "_self");
      }, 300);
    }
  },
};
</script>

<style lang="scss" module>
@import '~@/styles/animation.scss';
.box-slide-up {
  @include newgame-slide-up;
}
.box-slide-down {
  @include newgame-slide-down;
}
.box {
  position: absolute;
  z-index: 200;
  width: 100%;
  height: 100%;
  background: #ffffff;
  .title {
    position: relative;
    left: 21px;
    top: 6px;
    font-size: 13px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
    line-height: 23px;
  }
  .banner-content {
    min-height: 407px;
    overflow: hidden;
    position: relative;
    left: 21px;
    top: 12px;
    > ul {
      transition: transform 500ms linear;
      > li {
        float: left;
        position: relative;
        height: 435px;
        > div {
          width: 333px;
          height: 427px;
          position: relative;
          border-radius: 20px;
          box-shadow: 0px 0px 10px 0px rgba(60, 10, 10, 0.2);
          > img {
            width: 100%;
            height: 400px;
            border-radius: 20px;
          }
          .description {
            width: 100%;
            line-height: 28px;
            position: absolute;
            bottom: 64px;
            left: 0;
            background: rgba(0, 0, 0, 0.4);
            font-size: 15px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #eeeeee;
            text-align: center;
            > i {
              content: ' ';
              height: 6px;
              width: 6px;
              border-width: 1.2px 1.2px 0 0;
              border-color: #eeeeee;
              border-style: solid;
              transform: translateY(-50%) rotate(45deg);
              position: absolute;
              top: 50%;
            }
            > i:nth-child(2) {
              margin-left: 5px;
            }
          }
          .down {
            position: absolute;
            width: 100%;
            height: 64px;
            background-color: #fff;
            bottom: 0;
            left: 0;
            text-align: center;
            line-height: 64px;
            color: #27a32a;
            font-size: 15px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            border-bottom-left-radius: 20px;
            border-bottom-right-radius: 20px;
          }
        }
      }
    }
  }
}
.contorl {
  width: 100%;
  height: 5px;
  // background-color: pink;
  margin-top: 20px;
  > ul {
    height: 100%;
    // background-color: indigo;
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
    > li {
      width: 5px;
      height: 5px;
      border-radius: 50%;
      background: rgba(196, 196, 196, 0.65);
    }
    .choose {
      background: rgba(134, 134, 134, 0.67);
    }
  }
}
.back {
  width: 100%;
  height: 151px;
  position: absolute;
  left: 0;
  bottom: 0px;
  background-color: #fff;
  font-size: 17px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  text-align: center;
  > p {
    width: 100%;
    position: absolute;
    left: 0;
    top: 38px;
  }
  > div {
    > i {
      content: ' ';
      height: 8px;
      width: 8px;
      border-width: 1.5px 1.5px 0 0;
      border-color: #666666;
      border-style: solid;
      transform: translateY(-50%) rotate(-45deg);
      position: absolute;
      top: 18px;
    }
    > i:nth-child(2) {
      margin-top: 7px;
    }
  }
}

@media screen and (max-height: 680px) {
  .back {
    height: 91px;
    > p {
      display: none;
    }
    > div {
      animation: downAnimin 2s linear infinite;
    }
  }
}
@keyframes downAnimin {
  0% {
    transform: translateY(0px);
  }
  25% {
    transform: translateY(3px);
  }
  50% {
    transform: translateY(0px);
  }
  75% {
    transform: translateY(-3px);
  }
  100% {
    transform: translateY(0px);
  }
}
</style>
